import { Config } from "../latest/src/constants/AppServerConfig";
import makeApiRequest from "./makeApiCall";

const ehrEndPoint = Config.ehrConnectService + "ehr";

// get users from EHR system by last name
export const getRelatedEhrUsersByLastName = async (
    lastName: String,
    userId: string,
    dob : String,
) => {
    return await makeApiRequest(
        `${ehrEndPoint}/ehr_users?last_name=${lastName}&user_id=${userId}&dob=${dob}`,
        "GET"
    );
};

// create amd user by using i2i user id - contact - moz for query
export const createEhrUserByUserId = async (userId: string) => {
    return await makeApiRequest(`${ehrEndPoint}/upsert_user`, "POST", {
        // "ehr_user_id": "string",
        upsert_action_type: "CREATE",
        user_id: userId,
    });
};

// link amd user by using i2i user id - contact - moz for query
export const linkEhrUserByUserId = async (
    ehrUserId: string,
    userId: string
) => {
    return await makeApiRequest(`${ehrEndPoint}/upsert_user`, "POST", {
        ehr_user_id: ehrUserId,
        upsert_action_type: "UPDATE",
        user_id: userId,
    });
};

// Payment response
export const addCreditCardRequest = async(body : Object) => {

       return await makeApiRequest(`${ehrEndPoint}/add-card`, "POST", {
         ...body,
       });
};